import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormlyDetailedViewComponent } from '../../formly-detailed-view/formly-detailed-view.component';

@Component({
  selector: 'app-detailed-bulk-update-view',
  templateUrl: './detailed-bulk-update-view.component.html',
  styleUrl: './detailed-bulk-update-view.component.scss'
})
export class DetailedBulkUpdateViewComponent {
  @Output() buttonAction = new EventEmitter<any>();

  onButtonAction(event: any){
  this.buttonAction.emit(event);
  }
  
}
